const { partitionByPaper } = require("./partitionByPaper");
const { limitString } = require("./limitString");
const { buildPartitionErrorData } = require("./submitTagsFlow");

const mergeErrorData = (...parts) => {
  const bySerial = {};
  for (const part of parts) {
    for (const card of part?.cards || []) {
      if (!bySerial[card.serial]) {
        bySerial[card.serial] = { serial: card.serial, fields: [] };
      }
      const seen = new Set(bySerial[card.serial].fields.map((f) => f.key));
      for (const field of card.fields || []) {
        if (!seen.has(field.key)) {
          bySerial[card.serial].fields.push(field);
          seen.add(field.key);
        }
      }
    }
  }
  const cards = Object.values(bySerial).filter((c) => c.fields.length);
  return { cards };
};

const validateSelectedTags = (tagsData) => {
  const selected = (tagsData || []).filter((d) => d?.select);
  const partitionCards = [];
  for (const card of selected) {
    try {
      partitionByPaper(card);
    } catch (error) {
      partitionCards.push(
        buildPartitionErrorData(error)?.cards?.[0] || {
          serial: card.serial,
          fields: [{ key: "nome", value: error?.message || "Erro de partição" }],
        }
      );
    }
  }
  const widthErrors = limitString(selected);
  return mergeErrorData(widthErrors, { cards: partitionCards });
};

export { validateSelectedTags, mergeErrorData
};
